import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React, { createContext, useContext, useMemo } from "react";
//Limitless imports
import { useDevLogging } from "../../../common/hooks/dev-logging/DevLoggingContext";
import { useCustomer } from "./CustomerHook"; // Set the default state values for each context

var CustomerContext = createContext({});
export var CustomerContextProvider = function CustomerContextProvider(_ref) {
  var children = _ref.children,
      storageConfig = _ref.storageConfig;
  var hook = useCustomer(storageConfig);

  var _useDevLogging = useDevLogging(),
      stateTracker = _useDevLogging.stateTracker;

  var context = useMemo(function () {
    stateTracker.trackState({
      customer: hook.customer
    });
    return _objectSpread({}, hook);
  }, [hook.customer]); // pass the value in provider and return

  return /*#__PURE__*/React.createElement(CustomerContext.Provider, {
    value: context
  }, children);
};
export var useCustomerContext = function useCustomerContext() {
  return useContext(CustomerContext);
};